<template>
    <div class="create-comment-config">
        <div class="config-field">
            <label>{{ $t("taskModuleRules.commentText") }}</label>
            <a-textarea
                v-model="localConfig.comment"
                :placeholder="$t('taskModuleRules.enterCommentTextWithDynamicVariables')"
                :rows="4"
                @change="emitChange"
            />
            <small>
                {{ $t("taskModuleRules.dynamicVariablesExample") }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    name: "CreateCommentConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: { comment: '' }
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.create-comment-config {
    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }
    }
}
</style>
